/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Card_Previous_PhotoInputs */

const en_admin_resources_card_previous_photo = /** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous photo`)
};

const de_admin_resources_card_previous_photo = /** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Foto`)
};

const es_admin_resources_card_previous_photo = /** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto anterior`)
};

const fr_admin_resources_card_previous_photo = /** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo précédente`)
};

/** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */
const it_admin_resources_card_previous_photo = en_admin_resources_card_previous_photo;

/** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */
const pt_br2_admin_resources_card_previous_photo = en_admin_resources_card_previous_photo;

/** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */
const pl_admin_resources_card_previous_photo = en_admin_resources_card_previous_photo;

/** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */
const hu_admin_resources_card_previous_photo = en_admin_resources_card_previous_photo;

/** @type {(inputs: Admin_Resources_Card_Previous_PhotoInputs) => LocalizedString} */
const ro_admin_resources_card_previous_photo = en_admin_resources_card_previous_photo;

/**
* | output |
* | --- |
* | "Previous photo" |
*
* @param {Admin_Resources_Card_Previous_PhotoInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_card_previous_photo = /** @type {((inputs?: Admin_Resources_Card_Previous_PhotoInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Card_Previous_PhotoInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_card_previous_photo(inputs)
	if (locale === "de") return de_admin_resources_card_previous_photo(inputs)
	if (locale === "es") return es_admin_resources_card_previous_photo(inputs)
	if (locale === "fr") return fr_admin_resources_card_previous_photo(inputs)
	if (locale === "it") return it_admin_resources_card_previous_photo(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_card_previous_photo(inputs)
	if (locale === "pl") return pl_admin_resources_card_previous_photo(inputs)
	if (locale === "hu") return hu_admin_resources_card_previous_photo(inputs)
	return ro_admin_resources_card_previous_photo(inputs)
});
export { admin_resources_card_previous_photo as "admin.resources.card.previous_photo" }